import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { NotifyService } from "../services/notify-service";
import { EntityService } from "../services/entity-service";
import { EventService } from "../services/event-service";
import { ContractService } from "../services/contract-service";
import { WorkflowService } from "../services/workflow-service";

export function RLEntityInfoActions() {
    var directive: ng.IDirective = {
        restrict: "AE",
        template: require("/assets/app/templates/entity-info-actions.html"),
        scope: {
            entityID: "=rlEntityInfoActions",
            entityNoun: "@",
            listUrl: "@",
        },
        bindToController: {
            isDeletable: "=?"
        },
        controller: RLEntityInfoActionsController,
        controllerAs: "eiaVM"
    };
    return directive;
}

interface IRLEntityInfoActionsScope extends ng.IScope {
    entityID: string;
    entityNoun: string;
    listUrl: string;
}

class RLEntityInfoActionsController {
    static $inject = ["$scope", "$q", "$window", "workflowService", "notifyService", "entityService", "eventService", "contractService"];

    entityID: string;
    entityNoun: string;
    isDeletable: boolean = false;
    jobTitle: string;
    progressJobID: string;
    showJobProgressStatus: boolean;
    progressStatus: string;
    listUrl: string;
    showDeleteProgressCloseButton: boolean;

    constructor(
        private $scope: IRLEntityInfoActionsScope,
        private $q: ng.IQService,
        private $window: ng.IWindowService,
        private workflowService: WorkflowService,
        private notifyService: NotifyService,
        private entityService: EntityService,
        private eventService: EventService,
        private contractService: ContractService) {
        this.entityNoun = $scope.entityNoun;
        this.progressJobID = "";
        this.progressStatus = "";
        this.jobTitle = "";
        this.showJobProgressStatus = false;
        this.entityID = $scope.entityID;
        this.listUrl = $scope.listUrl;
        this.showDeleteProgressCloseButton = false;

        $scope.$watch(() => this.progressStatus, (newValue, oldValue) => {
            if (newValue == "Done") {
                this.showDeleteProgressCloseButton = true;
                //this.showJobProgressStatus = false;
                //this.$window.location.assign(this.listUrl);
            }
        });
    }

    Delete() {

        if (this.$window.confirm("Are you sure you want to delete this " + this.entityNoun + "?") && this.$window.confirm("Are you REALLY SURE you want to delete this " + this.entityNoun + "?")) {
            this.AllowDelete()
                .then((allowed) => {
                    if (allowed) {
                        this.notifyService.startProgress();
                        this.entityService.deleteEntity(this.entityID)
                            .then((result) => {
                                this.progressJobID = result.jobID;
                                this.jobTitle = result.jobTitle;
                                this.showJobProgressStatus = true;
                                this.showDeleteProgressCloseButton = false;
                            })
                            .finally(() => {
                                this.notifyService.endProgress();
                                this.$scope.$broadcast(Consts.Events.NotifyDone);
                            });
                    }
                    else {
                        alert("Unable to delete this Deal because there are one or more associated Accounting Records.");
                        this.$scope.$broadcast(Consts.Events.NotifyDone);
                    }
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    private AllowDelete() {
        var allowDeletePromise = this.$q.defer();
        var charTypeID = Utils.IdBuilder.splitEntityID(this.entityID).charTypeID;
        var parentRecID = Utils.IdBuilder.splitEntityID(this.entityID).recID;

        if (charTypeID == Consts.CharTypeIDs.transaction) {
            this.entityService.getEntityRelationships(this.entityID, Consts.CharTypeIDs.invoice)
                .then((result) => {
                    if (_.any(result, r => r.parentRecID == parentRecID)) {
                        allowDeletePromise.resolve(false);
                    }
                    else {
                        allowDeletePromise.resolve(true);
                    }
                });
        }
        else {
            allowDeletePromise.resolve(true);
        }
        return allowDeletePromise.promise;
    }

    public DeleteFormatFailedResultMessage(message: any): string {
        if (!_.isEmpty(message) && message == 'Success') {
            this.showDeleteProgressCloseButton = false;
            this.showJobProgressStatus = false;
            this.$window.location.assign(this.listUrl);
        }
        else {
            const failedRecords = message.split("|");
            var charTypeID = Utils.IdBuilder.splitEntityID(this.entityID).charTypeID;
            var charTypeName = Utils.CharTypeUtil.GetCharTypeName(charTypeID);
            let failedRecordsMessage =
                `<br\>Record could not be deleted:<br/>`;
            failedRecords.forEach(failedMessage => {
                const recMessage = failedMessage.split("=");
                const rID = Number(recMessage[0]);
                const failureReasons = recMessage[1].split(";");
                let decoratedFailureReasons = [];
                failureReasons.forEach(reason => {
                    decoratedFailureReasons.push(`[${reason}]`);
                });
                failedRecordsMessage += rID + ": " + decoratedFailureReasons.join("; ") + "<br/>";
            });
            return failedRecordsMessage;
        }
    }


}
